import { Platform } from "@prisma/client";
import { DiscordCategoryCreate, TriggerCreate } from "../../../libs/types/src";

/**
 * 2908TODO documentation
 * @param guildId
 * @param guildName
 * @param workspaceId
 * @param messageId
 * @param buttonId
 * @returns
 */

const workspaceId = "";
const guildId = "685243210829922350";

const guildAlias = "test";
const stepCommon: {
  platform: Platform;
  communityId: string;
  workspace: string;
} = {
  platform: "discord",
  communityId: guildId,
  workspace: workspaceId,
};
const alias = `${guildAlias}-ephemeral-demo`;
export const trigger: TriggerCreate = {
  platform: "discord",
  communityId: guildId,
  workspace: workspaceId,
  name: `Demo Ephemeral Flow`,
  authorUserId: "",
  type: "button_click",
  configs: {
    messages: [
      {
        id: "messageId",
        buttonIds: ["buttonId"],
      },
    ],
  },
  steps: [
    {
      id: `${alias}-continent-question-step`,
      isEntry: true,
      type: "send_survey",
      configs: {
        channelId: `{{interaction.channelId}}`,
        ephemeral: true,
        message:
          "\nI'll show you a quick example on how to onboard users through an ephemeral flow. This makes it easy for members to follow step by step, vs. having to read a wall of text, and jump in between channels. \nLet's start with first question.\n\nWhat region are you from?",
        type: "buttons", // by default it's "emojis"
        options: [
          { emoji: "🟢", id: "na", label: "North America" },
          { emoji: "⚪", id: "sa", label: "South America" },
          { emoji: "🟣", id: "asia", label: "Asia" },
          { emoji: "🟡", id: "africa", label: "Africa" },
          { emoji: "🟠", id: "europe", label: "Europe" },
          { emoji: "🟤", id: "oceania", label: "Oceania" },
          { emoji: "", id: "skip", label: "Prefer not to say" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "na",
            },
          },
        },
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "sa",
            },
          },
        },
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "asia",
            },
          },
        },
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "africa",
            },
          },
        },
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "europe",
            },
          },
        },
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "oceania",
            },
          },
        },
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "button",
              messageId: `{{${alias}-continent-question-step.messageId}}`,
              userId: "{{user.id}}",
              buttonId: "skip",
            },
          },
        },
      ],
    },
    {
      id: `${alias}-brings-you-here`,
      type: "send_survey",
      configs: {
        channelId: `{{interaction.channelId}}`,
        message: "What brings you here?",
        type: "buttons",
        ephemeral: true,
        options: [
          { emoji: "🎓", id: "learn", label: "Learn about your product" },
          {
            emoji: "👥",
            id: "others",
            label: "See what others are building",
          },
          { emoji: "💻", id: "trouble", label: "Troubleshoot" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-step3-student`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-brings-you-here.messageId}}`,
              buttonId: "learn",
            },
          },
        },
        {
          targetStepId: `${alias}-step3-see-others`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-brings-you-here.messageId}}`,
              buttonId: "others",
            },
          },
        },
        {
          targetStepId: `${alias}-step3-troubleshoot`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-brings-you-here.messageId}}`,
              buttonId: "trouble",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-step3-student`,
      type: "send_message",
      configs: {
        ephemeral: true,
        channelId: `{{interaction.channelId}}`,
        message: `Dots helps Discord communities improve their member experience by easily creating custom onboarding and support flows. \n\nYou should see sample flows on the left to play around. Feel free to ask any questions in <#958828554097930244>.`,
      },
      transitions: [{ targetStepId: `${alias}-final-message` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step3-see-others`,
      type: "send_message",
      configs: {
        ephemeral: true,
        channelId: `{{interaction.channelId}}`,
        message: `Amazing! Please join the discussion in our general channel.`,
      },
      transitions: [{ targetStepId: `${alias}-final-message` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step3-troubleshoot`,
      type: "send_message",
      configs: {
        ephemeral: true,
        channelId: `{{interaction.channelId}}`,
        message: "Thanks for being an early supporter! ",
      },
      transitions: [{ targetStepId: `${alias}-final-message` }],
    },
    {
      ...stepCommon,
      id: `${alias}-final-message`,
      type: "send_message",
      isGoal: true,
      configs: {
        ephemeral: true,
        channelId: `{{interaction.channelId}}`,
        message: `\n\n Great! Thanks for being part of our community! Let us know if you have questions or feedback!`,
      },
      transitions: [],
    },
  ],
};
